import type { FaireProductEntity } from "../../entity_types/product";

export const p_q2y4f8fp35: FaireProductEntity = {
  token: "p_q2y4f8fp35",
  type: "product",
  name: "Striped High-Rise Denim Shorts",
  brandToken: "b_elccldtdr7",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/54a1241a360d14f95c4b5ec3dfacefdb90fe1ee3a82aaf7f789ee8933e5fea7d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6746fc9eb28b8b19e7b4206221bc7e72941c682e0d584b034ad84867205f9fe.jpeg",
    "https://cdn.faire.com/fastly/1027e5be934f36d825383ba49c0ab69c906ae3f6e1a321316f3ee6caa0a53852.jpeg",
    "https://cdn.faire.com/fastly/34f460bb9b140421b0b56b3fe38399e6f1239fac664e55fc941ad1f7e1d6e398.jpeg",
    "https://cdn.faire.com/fastly/ff0ebadc914be1c77d36dee6bb59c07d6b3ac060a7fccf630bf3c82d5c4ea4bc.jpeg",
    "https://cdn.faire.com/fastly/bcb4eca3d2902d8b8f627bf0147dd748347a49a4212f00c09aaf69cb13b3469e.jpeg",
    "https://cdn.faire.com/fastly/348766af0909e961d05404ba38cbdcf9ab62f7ec903336790047d8f13ba9463e.jpeg",
    "https://cdn.faire.com/fastly/5f0d752d048d41408424f952ff5a1a3db6453d7dd08144328105f32af621bd97.jpeg",
    "https://cdn.faire.com/fastly/1714a19e4a04df9f3f75d9975a08af9458c13a0ab11a5ea277876e29aa23dde4.jpeg",
    "https://cdn.faire.com/fastly/6f09b7a5dcc6b53edaabcc892eac54c626da5458822f056aa574b660e1ce30b9.jpeg",
    "https://cdn.faire.com/fastly/0687b711bb7bab70e60ba763fd6ad82058b48b63bc0fec63b427d7be9a534442.jpeg",
    "https://cdn.faire.com/fastly/d016b7d21e3a4b1ce1c5290bf00a70bc8e62af8123cfd264564e3fef0424d931.jpeg",
    "https://cdn.faire.com/fastly/345a451c0f5d59faefa306f6d9c04459d20a626e0cb6acacb799c155b65c971c.jpeg",
    "https://cdn.faire.com/fastly/ef90f49cdf024bf2f85cab1a136f5af6950b0d9f2fae41758ee0bbbe664be7de.jpeg",
    "https://cdn.faire.com/fastly/a42d9e62b0c475b3e36ca0f302fb9edd4381672f4ee30cf882ef64fde6050da5.jpeg",
    "https://cdn.faire.com/fastly/f56301ee7316081644408103a8decf668c55d0380b534851bcb080b6f6b4205c.jpeg",
    "https://cdn.faire.com/fastly/910d0e5dfe6d0105cfe621ac70bf4930431fd127f27e213f98c0277825388248.jpeg",
    "https://cdn.faire.com/fastly/672359179a9d3aa3aa5f1ca9ca88c42e992254f2b1e05baea6812a4e9486c09a.jpeg",
    "https://cdn.faire.com/fastly/84ea2d30bf720ff08a1027aa12c9a3b3071f80b97c4e1bc316c0438c2a8ad7a4.jpeg",
    "https://cdn.faire.com/fastly/e4949ba779729f1017584bddba43433c6a5b217d1794da00fbd8749992ac4e6b.jpeg",
    "https://cdn.faire.com/fastly/4bfd0ffa4fe73b548e0db47981dbdf790c3f0945057d490b1305cc4c5e478077.jpeg",
    "https://cdn.faire.com/fastly/7e8a8edaa8a1678ce8547194fdd17756e26f392284e7e0bebc44de6d680b91ff.jpeg",
    "https://cdn.faire.com/fastly/23ae7047f9def9545de0fe3c65dbf80b82163cde9af84fd666c7886f86b83264.jpeg",
    "https://cdn.faire.com/fastly/4d3191da868971b0f2a39f8f12e782af9b73140c96913730a7f64a712880fb90.jpeg",
    "https://cdn.faire.com/fastly/10c72d5bd30837ac880cff287b988aff3405e40493eb083e13b8f5ca0b3047e0.jpeg",
  ],
  priceDollars: 36.02,
  description:
    "These stylish high-rise denim shorts feature bold red and white vertical stripes, a rope drawstring waist for adjustability, and frayed raw hems for a relaxed, lived-in look. Oversized patch pockets add practicality, while the durable denim construction ensures everyday wearability. Perfect for casualwear or western-inspired collections.\n  \n  Features:\n  • 78% Cotton 22% Polyester\n  • S-L: 2-2-2\n  • Bold red and white stripe pattern\n  • Frayed raw hems for a casual vibe\n  • ope drawstring waist for adjustable fit\n  • Made in China",
  tags: [],
  msrpDollars: 72.03,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:16.827Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
